<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>车桓科技管理系统</h2>
        <p>请登录您的账号</p>
      </div>
      
      <el-form
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="handleLogin"
            class="login-button">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return false
        }
        
        this.loading = true
        this.$http.post('/Auth/login', this.loginForm)
          .then(res => {
            this.loading = false
            if (res.data.success) {
              // 保存 Token 和用户信息
              const token = res.data.data.token
              const userInfo = {
                userId: res.data.data.userId,
                username: res.data.data.username,
                realName: res.data.data.realName,
                role: res.data.data.role
              }
              
              localStorage.setItem('token', token)
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
              
              // 设置 axios 默认 header
              this.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
              
              this.$message.success('登录成功')
              
              // 跳转到首页
              this.$router.push('/vehicle-trade/list')
            } else {
              this.$message.error(res.data.message || '登录失败')
            }
          })
          .catch(err => {
            this.loading = false
            if (err.response && err.response.data && err.response.data.message) {
              this.$message.error(err.response.data.message)
            } else {
              this.$message.error('网络错误，请重试')
            }
          })
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.login-box {
  width: 100%;
  max-width: 620px;
  padding: 48px 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h2 {
  font-size: 28px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.login-header p {
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
}

.login-divider {
  display: none;
}

.login-form {
  margin-top: 0;
}

.login-form >>> .el-form-item {
  margin-bottom: 24px;
}

.login-form >>> .el-input__inner {
  height: 48px;
  font-size: 15px;
  padding-left: 45px;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  transition: all 0.2s;
  background: #fafbfc;
}

.login-form >>> .el-input__inner:hover {
  border-color: #c0c4cc;
  background: #fff;
}

.login-form >>> .el-input__inner:focus {
  border-color: #409eff;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.login-form >>> .el-input__prefix {
  left: 15px;
  font-size: 16px;
  color: #909399;
}

.login-form >>> .el-input__prefix .el-icon-user,
.login-form >>> .el-input__prefix .el-icon-lock {
  font-size: 16px;
}

.login-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 6px;
  background: #409eff;
  border: none;
  transition: all 0.2s;
  margin-top: 8px;
}

.login-button:hover {
  background: #66b1ff;
}

.login-button:active {
  background: #3a8ee6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-box {
    max-width: 100%;
    padding: 40px 32px;
  }
  
  .login-header h2 {
    font-size: 24px;
  }
  
  .login-header p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .login-box {
    padding: 32px 24px;
  }
  
  .login-header h2 {
    font-size: 22px;
  }
}
</style>
